import { CopilotScript, DashboardMessage } from '@coach-bot/data-access/shared/models';
import { BackgroundAction } from '../enums';
import { safeSendChromeRuntimeMessage, withChromeRuntime } from '../utils';

export class ServiceWorkerCommunicationService {
  async sendMessage<T>(action: string): Promise<T> {
    return new Promise(resolve => {
      const result = withChromeRuntime(() => {
        safeSendChromeRuntimeMessage<{ action: string }, T>({ action }, resolve);
        return {};
      });
      if (result === undefined) {
        console.warn('sendMessage: chrome.runtime is undefined');
        resolve({} as T);
      }
    });
  }

  async getChromeProfileEmail(): Promise<string> {
    const { profileEmail } = await this.sendMessage<{ profileEmail: string }>(BackgroundAction.GetProfileEmail);
    return profileEmail;
  }

  async getCopilotScripts(): Promise<CopilotScript[]> {
    const { copilotScripts } = await this.sendMessage<{ copilotScripts: CopilotScript[] }>(
      BackgroundAction.GetCopilotScripts
    );
    if (!copilotScripts) {
      throw new Error('Could not get copilot scripts from the service worker.');
    }
    return copilotScripts;
  }

  async getBackendURL(): Promise<string> {
    const { backendUrl } = await this.sendMessage<{ backendUrl: string }>(BackgroundAction.GetBackendUrl);
    return backendUrl;
  }

  async getLatestDashboardMessage(): Promise<DashboardMessage | null> {
    const { latestDashboardMessage } = await this.sendMessage<{ latestDashboardMessage: DashboardMessage | null }>(
      BackgroundAction.GetLatestDashboardMessage
    );
    return latestDashboardMessage;
  }
}
